import { ITranslations } from 'types/common';
import en from 'translations/en/productCategoriesTable.json';
import pl from 'translations/pl/productCategoriesTable.json';
import sl from 'translations/sl/productCategoriesTable.json';
import { ProductCategoriesTableTransFields } from './types';

export const productCategoriesTableTranslations: ITranslations<ProductCategoriesTableTransFields> = {
  name: 'productCategoriesTable',
  en,
  pl,
  sl,
};
